import { FOOTER_TEXT } from "../../appConstants";

const Footer = () => {
    return (
      <div className="App-footer">
        { FOOTER_TEXT }
      </div>
    );
}

export default Footer;
